import API from "@utils/plugins/API";

const StatisticalDivisionService = {
  all: (params) => {
    return API.get("statistical-divisions", { params: params });
  },
  create: (name, name_eng, description, sub_area_id) => {
    return API.post("statistical-divisions", {
      name,
      name_eng,
      description,
      sub_area_id,
    });
  },
  update: (id, name, name_eng, description, sub_area_id) => {
    return API.put(`statistical-divisions/${id}`, {
      name,
      name_eng,
      description,
      sub_area_id,
    });
  },
  find: (id) => {
    return API.get(`statistical-divisions/${id}`);
  },
  destroy: (id) => {
    return API.delete(`statistical-divisions/${id}`);
  },
};

export default StatisticalDivisionService;
